import React from 'react';
import {useSortable} from '@dnd-kit/sortable';
import {CSS} from '@dnd-kit/utilities';

interface SortableData {
    id: string;
    children: React.ReactNode;
    dragHandle?: React.ReactNode;
}
export function SortTableItem({id, children, dragHandle}: SortableData) {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition
    } = useSortable({id});

    const style = {
        transform: CSS.Transform.toString(transform),
        transition
    };

    return (
        <div ref={setNodeRef} style={style} {...attributes}>
            {dragHandle && <span className="drag-handle" {...listeners}>{dragHandle}</span>}
            {children}
        </div>
    );
}